import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";
import {
  oldFractionCleanupMiddleware,
  jigsawAuthMiddleware,
  predicateMiddleware,
  bridgeFailureMiddleware,
  gaMiddleware,
  libraryRemountTest,
  bridgeMiddleware,
  syncingMiddleware
} from "./middleware";
import { history as routerHistory } from "./router";

const configureStore = (initialState = {}) => {
  const savedInitialState = initialState;
  const composeEnhancers = composeWithDevTools({ name: "Bookshelf" });

  return createStore(
    rootReducer,
    savedInitialState,
    // Do we want react router for our history - router saved in our state?
    // also, should we be persisting user data?
    //composeWithDevTools(applyMiddleware(historyMiddleware, thunk, persist))
    composeEnhancers(
      applyMiddleware(
        thunk,
        oldFractionCleanupMiddleware,
        predicateMiddleware,
        jigsawAuthMiddleware,
        bridgeFailureMiddleware,
        gaMiddleware,
        libraryRemountTest,
        bridgeMiddleware,
        syncingMiddleware
      )
    )
  );
};

export const store = configureStore({
  router: { action: routerHistory.action, location: routerHistory.location }
});
